import { authHeaders } from "../../utils/auth";

const API_BASE = process.env.REACT_APP_BACKEND_API_URL || "";

export type AccessStatus = "pending" | "approved" | "rejected";

export interface AccessRequest {
  email: string;
  status: AccessStatus;
  requestedAt?: string;
  lastRequestedAt?: string;
  requestCount?: number;
  decidedAt?: string;
  codeExpiresAt?: string;
  codeUsedAt?: string;
  failedRedeems?: number;
  codeSent?: boolean;
}

async function call<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: { "Content-Type": "application/json", ...authHeaders(), ...(init.headers || {}) },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = body?.detail;
    const message =
      res.status === 401
        ? "Your session has expired. Please sign in again."
        : res.status === 403
          ? "This page is for mRehab admins only."
          : typeof detail === "string"
            ? detail
            : detail?.error === "EMAIL_FAILED"
              ? "The code was created but the email could not be sent."
              : `Request failed (${res.status})`;
    throw new Error(message);
  }
  return body as T;
}

export function listRequests(status: AccessStatus): Promise<AccessRequest[]> {
  return call<{ requests: AccessRequest[] }>(`api/access/requests?status=${status}`).then((r) => r.requests);
}

export function decideRequest(email: string, decision: "approved" | "rejected"): Promise<AccessRequest> {
  return call<{ request: AccessRequest }>("api/access/requests/decide", {
    method: "POST",
    body: JSON.stringify({ email, decision }),
  }).then((r) => r.request);
}

export function resendCode(email: string): Promise<{ codeExpiresAt: string }> {
  return call("api/access/requests/resend-code", { method: "POST", body: JSON.stringify({ email }) });
}
